export default class DeviceOrientationState{
    constructor(){
      this._state	= { x: 0, y: 0, z: 0 };
    }
    
    callback= (event) =>{ 
      this.onDeviceOrientation(event); 
    }
    
    onDeviceOrientation	= (event) =>{
        this._state.x	= (!event.alpha ? 0 : event.alpha) * Math.PI / 180;
        this._state.y	= (!event.beta  ? 0 : event.beta ) * Math.PI / 180;
        this._state.z	= (!event.gamma ? 0 : event.gamma) * Math.PI / 180;
    }
    
    angleX	= () =>{
      return this._state.x;
    }
  
    angleY	= ()=>{
      return this._state.y;
    }
  
    angleZ	= ()=>{
      return this._state.z;
    }

    enable = () =>{
        window.addEventListener('deviceorientation', this.callback);
    }
    
    disable = () =>{
        window.removeEventListener('deviceorientation', this.callback);
    }
  }